__turbopack_context__.v({
  "circle": "nf4Diq_circle",
  "circleBg": "nf4Diq_circleBg",
  "container": "nf4Diq_container",
});
